import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import _ from 'lodash';

export function translateInventoryCode(inventory) {
  switch (inventory) {
    case 1:
    case '1':
      return 'Low Stock Alert';
    case 2:
    case '2':
      return 'Out of Stock Alert';
    default:
      return 'All';
  }
}

export function libraryItemStart({ outletIds, category, inventory }) {
  pushClevertapEvent('Library Item Start', {
    'Current Selected Outlet': outletIds,
    'Current Category Filter': category || 'All',
    'Current Inventory Filter': translateInventoryCode(inventory),
  });
}

export function libraryItemCreate(
  createdItem,
  allOutlet,
  user,
  search,
  outlets
) {
  const outletName = _getOutletName(search.outletIds[0], outlets);

  let eventName = 'Item Create';
  if (createdItem.is_sales_type_price) {
    eventName += ' Sales Type Pricing';
  } else {
    eventName += ' Basic Pricing';
  }

  if (allOutlet) {
    eventName += ' All Outlet';
  } else {
    eventName += ' One Outlet';
  }

  const employeeRole = _getEmployeeRole(user);

  const variants = _constructVariants(createdItem);

  pushClevertapEvent(eventName, {
    'Item ID': createdItem.id,
    'Item Name': createdItem.name,
    Variants: variants,
    'Outlet ID': createdItem.outlet_id,
    'Outlet Name': outletName,
    'Employee Role': employeeRole,
    'Employee Email': user.email,
  });
}

const _getOutletName = (selectedOutletId, allOutlets) => {
  let outletName = '';
  allOutlets.forEach(outlet => {
    if (outlet.id === selectedOutletId) {
      outletName = outlet.name;
    }
  });
  return outletName;
};

const _getEmployeeRole = user => {
  let employeeRole = 'Staff';
  if (user.is_manager) {
    employeeRole = 'Manager';
  } else if (user.is_owner) {
    employeeRole = 'Owner';
  }
  return employeeRole;
};

const _constructVariants = item => {
  const variants = [];
  item.item_variants.forEach(iv => {
    const salesTypePrices = [];

    if (iv.sales_type_items) {
      iv.sales_type_items.forEach(st => {
        const stPrice = {
          id: st.sales_type_id,
          name: st.sales_type_name,
          price: st.sales_type_price,
        };
        salesTypePrices.push(stPrice);
      });
    }

    const variant = {
      id: iv.id,
      name: iv.name,
      sku: iv.sku,
      price: iv.price,
      sales_type_prices: salesTypePrices,
    };
    variants.push(variant);
  });
  return variants;
};

const _getSelectedCategory = (search, categories) => {
  let selectedCategory = '';

  if (!search.categoryId) {
    selectedCategory = 'All Categories';
  } else if (parseInt(search.categoryId) === 0) {
    selectedCategory = 'All Categories';
  } else {
    categories.forEach(category => {
      if (parseInt(search.categoryId) === category.id) {
        selectedCategory = category.name;
      }
    });
  }
  return selectedCategory;
};

const _getSelectedInventory = (search, inventories) => {
  let selectedInventory = '';

  if (!search.typeInventoryId) {
    selectedInventory = 'All inventories';
  } else if (parseInt(search.typeInventoryId) === 0) {
    selectedInventory = 'All inventories';
  } else {
    inventories.forEach(inventory => {
      if (parseInt(search.typeInventoryId) === parseInt(inventory.id)) {
        selectedInventory = inventory.name;
      }
    });
  }
  return selectedInventory;
};

export function libraryItemUpdate(updatedItem, oldItem, user, search, outlets) {
  const outletName = _getOutletName(search.outletIds[0], outlets);

  let eventName = 'Item Update';
  if (updatedItem.is_sales_type_price) {
    eventName += ' Sales Type Pricing';
  } else {
    eventName += ' Basic Pricing';
  }

  const employeeRole = _getEmployeeRole(user);

  const newVariants = _constructVariants(updatedItem);

  const oldVariants = _constructVariants(oldItem);

  pushClevertapEvent(eventName, {
    'Item ID': updatedItem.id,
    'Old Item Name': oldItem.name,
    'Item Name': updatedItem.name,
    'Old Variants': oldVariants,
    'New Variants': newVariants,
    'Outlet ID': updatedItem.outlet_id,
    'Outlet Name': outletName,
    'Employee Role': employeeRole,
    'Employee Email': user.email,
  });
}

export function libraryManageSalesType(item, user, search, outlets) {
  const eventName = 'Manage Sales Type on Item';
  const employeeRole = _getEmployeeRole(user);
  const variants = _constructVariants(item);
  const outletName = _getOutletName(search.outletIds[0], outlets);

  pushClevertapEvent(eventName, {
    'Item ID': item.id,
    'Item Name': item.name,
    Variants: variants,
    'Outlet ID': item.outlet_id,
    'Outlet Name': outletName,
    'Employee Role': employeeRole,
    'Employee Email': user.email,
  });
}

/**
 * @param eventName 'modify' or 'replace'
 */
export function libraryItemImport(
  eventName,
  user,
  search,
  outlets,
  categories,
  inventories
) {
  const outletName = _getOutletName(search.outletIds[0], outlets);
  const employeeRole = _getEmployeeRole(user);
  const selectedCategory = _getSelectedCategory(search, categories);
  const selectedInventory = _getSelectedInventory(search, inventories);

  pushClevertapEvent(`Library Item Import ${eventName}`, {
    'Business Id': user.business.id,
    'Current Selected Outlet': outletName,
    'Current Category Filter': selectedCategory,
    'Current Inventory Filter': selectedInventory,
    'Employee Role': employeeRole,
    'Employee Email': user.email,
  });
}

export function libraryItemDelete({ item }) {
  pushClevertapEvent('Library Item Delete', {
    Name: item.name,
    Category: item.category_id,
    Variants: _.map(item.item_variants, 'id'),
    Trackings: _.map(item.item_variants, 'track_stock'),
    Modifiers: _.map(item.active_modifiers, 'id'),
  });
}

export function libraryItemStartTrackingStockAlert(trackedItems, itemName) {
  return pushClevertapEvent('Library Item Start Tracking Stock Alert', {
    'Item Variant': trackedItems,
    'Item Name': itemName,
    'Item Variant Name': _.map(trackedItems, 'name'),
    'In Stock': _.map(trackedItems, 'in_stock'),
    'Stock Alert': _.map(trackedItems, 'stock_alert'),
  });
}

export function libraryItemRemoveTrackingStockAlert(trackedItems, itemName) {
  return pushClevertapEvent('Library Item Remove Tracking Stock Alert', {
    'Item Variant': trackedItems,
    'Item Name': itemName,
    'Item Variant Name': _.map(trackedItems, 'name'),
    'In Stock': _.map(trackedItems, 'in_stock'),
    'Stock Alert': _.map(trackedItems, 'stock_alert'),
  });
}

export function libraryItemExport() {
  pushClevertapEvent('Library Item Export');
}

export function cogsTrackingItem({ itemVariant, cogsTrack }) {
  const eventName = !cogsTrack
    ? 'COGS Tracking Start Item'
    : 'COGS Tracking Manage Item';
  pushClevertapEvent(eventName, {
    Name: _.map(itemVariant, 'name'),
    'Average Cost': _.map(itemVariant, 'cogs'),
  });
}

export function updateToAllOutletClicked(itemId, itemName) {
  pushClevertapEvent('Update to All outlets - Clicked', {
    'Item Id': itemId,
    'Item Name': itemName,
  });
}

export function updateToAllOutletSuccess(itemId, itemName) {
  pushClevertapEvent('Update to All outlets - Success', {
    'Item Id': itemId,
    'Item Name': itemName,
  });
}

export function updateToAllOutletFailed(itemId, itemName, reason) {
  pushClevertapEvent('Update to All outlets - Failed', {
    'Item Id': itemId,
    'Item Name': itemName,
    Reason: reason,
  });
}
